import { createAction } from '@reduxjs/toolkit';
import { createPromiseAction } from '../utils/saga-promise';

export const fetchRemoteFazModuleDisable = createPromiseAction(
  'fmgRemoteFaz/FETCH_REMOTE_DATA'
);
export const setRemoteFazModuleDisable = createAction(
  'fmgRemoteFaz/SET_REMOTE_DATA'
);
